var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75677 0C4.37704 0 0 4.374 0 9.75C0 15.126 4.37704 19.5 9.75677 19.5C15.1365 19.5 19.5135 15.126 19.5135 9.75C19.5135 4.374 15.1365 0 9.75677 0ZM9.75677 18C5.20461 18 1.50104 14.299 1.50104 9.75C1.50104 5.201 5.20461 1.5 9.75677 1.5C14.3089 1.5 18.0125 5.201 18.0125 9.75C18.0125 14.299 14.3089 18 9.75677 18ZM12.2886 9.21899C12.5818 9.51199 12.5818 9.98703 12.2886 10.28L9.28647 13.28C9.14037 13.426 8.94821 13.5 8.75607 13.5C8.56394 13.5 8.37178 13.427 8.22568 13.28C7.93247 12.987 7.93247 12.512 8.22568 12.219L10.6974 9.74902L8.22568 7.27905C7.93247 6.98605 7.93247 6.51102 8.22568 6.21802C8.51888 5.92502 8.99424 5.92502 9.28745 6.21802L12.2886 9.21899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIcon);
export default __webpack_public_path__ + "static/media/buttonIcon.a4885bdfde234eefa05b8644c8d8b303.svg";
export { ForwardRef as ReactComponent };